import styled, { css } from 'styled-components'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

const inlineStyles = css`
  .uw .uw__title {
    line-height: 31px !important;
    font-size: 26px !important;
    font-weight: 700 !important;
    margin-bottom: 8px !important;
    margin-top: 40px;
    color: #333 !important;
    text-align: left !important;
  }

  [role='dialog'] & .uw .uw__title {
    margin-top: 0;
  }

  .uw .uw__paper-upload-ui p {
    line-height: 35px !important;
    font-size: 16px !important;
    margin-top: 0;
    margin-bottom: 10px;
    font-weight: 400 !important;
    color: #333 !important;
    text-align: left !important;
  }

  .uw .uw__legal-copy {
    margin: 12px 0px 0px 0px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    padding-bottom: 0;
  }

  .uw .uw__textarea {
    margin-bottom: 8px;
    border-radius: 8px;
  }

  .uw .uw__form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .uw .uw__paper-upload-ui button {
    font-size: 16px !important;
    font-weight: bold !important;
    line-height: 22.8px !important;
    padding: 12px 0px !important;
    margin-right: 2px !important;
    border-radius: 2rem !important;
    span {
      padding-right: 0.4375rem !important;
    }
  }
`

export const UploadWidgetContainer = styled.div<{ pasteOnly: boolean }>`
  .uw {
    max-width: none;
  }

  .uw .uw__wrapper {
    box-shadow: none;
    border: 0;
    padding-top: 0;
  }

  .uw .uw__paper-upload-ui {
    ${AspiraStack};
    font-stretch: 100%;
    max-width: none;
    padding: 0;
  }

  .uw .uw__textarea-wrapper {
    border-radius: 4px;

    > .uw__textarea {
      margin-bottom: 0;
    }
  }

  ${({ pasteOnly }) => (pasteOnly ? inlineStyles : '')}
`
